"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferContentWithIdFE = exports.OfferContent = exports.OfferQualityEnum = void 0;
const zod_1 = require("zod");
const types_1 = require("../types");
const types_2 = require("./campaignOffer/types");
exports.OfferQualityEnum = zod_1.z.enum(['Featured', 'Good', 'Great', 'Legendary']);
exports.OfferContent = zod_1.z.object({
    campaign: types_1.PublisherCampaign,
    offer: types_2.CampaignOffer,
});
exports.OfferContentWithIdFE = zod_1.z.object({
    campaign: types_1.PublisherCampaignFE,
    offer: types_2.CampaignOfferDocFE,
});
